import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { MiniChips } from "@website/ui/mini-chips";
import { numberConvert } from "@website/utils/number-convert";
import snappProBadge from "@website/widget/header/assets/pro_badge.svg";
export type AccommodationCardBadgesProperties = {
  snappProDiscountPercent?: number;
  list?: Array<{
    title: string;
    description: string;
    color: string;
  }>;
};
export const AccommodationCardBadges: React.FC<AccommodationCardBadgesProperties> = t0 => {
  const $ = _c(8);
  const {
    list,
    snappProDiscountPercent
  } = t0;
  const shouldShowSnappProDiscount = typeof snappProDiscountPercent === "number" && snappProDiscountPercent > 0;
  if (!list?.length && !shouldShowSnappProDiscount) {
    return null;
  }
  let t1;
  if ($[0] !== shouldShowSnappProDiscount || $[1] !== snappProDiscountPercent) {
    t1 = shouldShowSnappProDiscount && <MiniChips StartIcon={<LazyImage src={snappProBadge.src} alt="Snapp Pro" width={24} height={14} />} text={numberConvert(`${snappProDiscountPercent}٪ تخفیف پرو`, {
      locale: "fa"
    })} variant="round-contained" color="pro" />;
    $[0] = shouldShowSnappProDiscount;
    $[1] = snappProDiscountPercent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== list) {
    t2 = list?.map(_temp);
    $[3] = list;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className="no-scrollbar mt-[2px] flex items-center gap-2 overflow-auto">{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
function _temp(badge, index) {
  return <MiniChips key={`${badge.title}-${index}`} text={numberConvert(badge.title, {
    locale: "fa"
  })} textClassName="!text-extra-caption px-1" variant="round-accent" />;
}